import { combineReducers } from 'redux';

import items from './items';
import options from './options';
import selection from './selection';
import listedit from './listedit';
import categories from './categories';

export default combineReducers({ items, options, selection, listedit, categories });
